import React, { useEffect, useState } from 'react';
import './index.css'
import DownloadIcon from '@mui/icons-material/Download';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ExcelLogo from '../../../assets/272697_excel_icon.png'
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useMsal } from "@azure/msal-react";
import axios from 'axios';
import { Box, CircularProgress } from "@mui/material";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ExcelUpdate = ({ getFileDetails, url, templateName, isUploadFileSelected, excelLoader }) => {
    const [data, setData] = useState(null);
    const [fileName, setFileName] = useState('');
    const [showError, setShowError] = useState("");
    const [headers, setHeaders] = useState([]);
    const { instance, accounts } = useMsal();
    const getHeaderTemplate = async () => {

        const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
        instance?.setActiveAccount(account);
        const tokenRequest = {
            scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
        };
        const response = await instance?.acquireTokenSilent(tokenRequest);
        const accessToken = response?.accessToken;
        const headerTemplateUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}${url}`
        axios.get(headerTemplateUrl,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`, //the token is a variable which holds the token
                    withCredentials: true
                },
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode"),
                    userEmail: localStorage.getItem("data"),
                    ltRole: localStorage.getItem("LTRole"),
                    cdRole: localStorage.getItem("CDRole"),
                    ltRegion: localStorage.getItem("LTRegion")
                }
            }
        )
            .then(function (response) {
                console.log("repons", response?.data);
                setHeaders(response?.data)
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    useEffect(() => {
        getHeaderTemplate()
    }, [])

    const handeDeleteIcon = () => {
        isUploadFileSelected();
        setData(null);
        setFileName('');
        getFileDetails('', {});
        setShowError('');
    }
    const handleFileUpload = (event) => {
        clearFileDetails();
        const file = event?.target?.files[0];
        const formData = new FormData();
        formData.append("file", file);
        isUploadFileSelected();
        if (!file) {
            setShowError("No file selected")
            return;
        }
        if (file && file.type === 'text/csv') {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 5) {
                setShowError("File size exceeds 5MB. Please upload a smaller file.");
                return;
            }
            for (let pair of formData.entries()) {
                setData(pair[1]);
                setFileName(file.name)
                getFileDetails(file.name, formData);
            }

        } else {
            setShowError('Please upload a CSV file.');
        }
        event.target.value = "";
    }

    const clearFileDetails = () => {
        setData(null);
        setFileName('');
        getFileDetails('', {});
        setShowError("");
    }

    const handleDownload = () => {
        // const csvContent = `data:text/csv;charset=utf-8,${headers}\n`;
        // const encodedUri = encodeURI(csvContent);
        // const link = document.createElement('a');
        // link.setAttribute('href', encodedUri);
        // link.setAttribute('download', `${templateName}.csv`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        const blob = new Blob([headers], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${templateName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (

        excelLoader ?
            <Box style={{ width: '100%', height: '100px', textAlign: 'center' }}>
                <CircularProgress color="inherit" style={{ width: '30px', height: '30px', textAlign: 'center' }} />
            </Box>
            : <>
                <p className="font-size">Download the excel template</p>
                <button onClick={handleDownload} className="download-button">Download <DownloadIcon /></button>
                <div className="file-upload-container">
                    <p className="font-size">Upload the file for processing</p>
                    <Button
                        component="label"
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<UploadFileIcon />}
                        style={{ backgroundColor: '#000', width: 150, height: 30, textTransform: 'none', color: '#FFF' }}
                    >
                        Upload File
                        <VisuallyHiddenInput
                            type="file"
                            accept=".csv"
                            onChange={handleFileUpload}
                        />
                    </Button>
                    {showError && <p style={{ color: 'red' }}>{showError}</p>}
                    <p className="font-size">File should be in '.csv' format</p>
                    <p className="font-size">Max file size that can be uploaded is 5MB</p>
                    {data && (
                        <div className="file-container">
                            <img style={{ paddingTop: "10px" }} src={ExcelLogo} alt='logo' width={20} height={20} />
                            <span className="font-size" style={{ paddingTop: "10px" }}>{fileName}</span>
                            <IconButton onClick={handeDeleteIcon}>
                                <Delete />
                            </IconButton>
                        </div>
                    )}

                </div>
            </>
    )
}

export default ExcelUpdate